import TabViewState from '../store/schema/TabViewState';
import activateTab from './activateTab';
import { action } from 'satcheljs/lib/legacy';
import { getStore } from '../store/tabStore';

function getNextVisibleTab(tabs: TabViewState[], startIndex: number): TabViewState {
    if (startIndex < 0) {
        startIndex = 0;
    }
    for (let i = startIndex; i < tabs.length; i++) {
        if (tabs[i].isShown) {
            return tabs[i];
        }
    }

    for (let i = startIndex - 1; i >= 0; i--) {
        if (tabs[i].isShown) {
            return tabs[i];
        }
    }

    return null;
}

export default action('setTabIsShown')(function(viewState: TabViewState, isShown: boolean) {
    if (viewState.isShown != isShown) {
        viewState.isShown = isShown;

        // Blink the tab when show it. This will be reset to false when it is activated
        viewState.blink = isShown;

        if (viewState.isActive && !isShown) {
            const store = getStore();
            const index = store.tabs.indexOf(viewState);
            const nextActiveTab =
                store.tabs.filter(tab => tab.id == viewState.parentTabId && tab.isShown)[0] ||
                getNextVisibleTab(store.tabs, index);
            if (nextActiveTab) {
                activateTab(nextActiveTab);
            }
        }
    }
});
